import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "locale"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React, { useCallback, useMemo } from 'react';
import dayjs from 'dayjs';
import cx from 'classnames';
import DatePicker from 'antd/lib/date-picker';
import { ConfigConsumer } from '../../ConfigProvider';
import zhCN from '../locale/zh';
var RangeDatePicker = /*#__PURE__*/React.memo(_ref => {
  var value = _ref.value,
    onChangeInProps = _ref.onChange,
    locale = _ref.locale,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = React.useState([dayjs(), dayjs()]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    studyDatetime = _React$useState4[0],
    setstudyDatetime = _React$useState4[1];
  var keys = useMemo(() => [locale.today, locale.yesterday, locale.lastThreeDay, locale.lastWeek, locale.lastMonth, locale.lastHalfYear, locale.all], [locale]);
  var quickSearch = useMemo(() => ({
    [keys[0]]: [dayjs(), dayjs()],
    [keys[1]]: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
    [keys[2]]: [dayjs().subtract(2, 'day'), dayjs()],
    [keys[3]]: [dayjs().subtract(6, 'day'), dayjs()],
    [keys[4]]: [dayjs().subtract(1, 'month'), dayjs()],
    [keys[5]]: [dayjs().subtract(6, 'month'), dayjs()],
    [keys[6]]: []
  }), [keys]);
  var isDateEqual = useCallback((date, dates) => {
    var _date$, _dates$, _dates$2, _date$2;
    return ((_date$ = date[0]) === null || _date$ === void 0 ? void 0 : _date$.format('YYYY-MM-DD')) === ((_dates$ = dates[0]) === null || _dates$ === void 0 ? void 0 : _dates$.format('YYYY-MM-DD')) && ((_dates$2 = dates[1]) === null || _dates$2 === void 0 ? void 0 : _dates$2.format('YYYY-MM-DD')) === ((_date$2 = date[1]) === null || _date$2 === void 0 ? void 0 : _date$2.format('YYYY-MM-DD'));
  }, []);
  var onChange = useCallback(dates => {
    if (dates) {
      setstudyDatetime(dates);
      onChangeInProps === null || onChangeInProps === void 0 ? void 0 : onChangeInProps(dates);
    }
  }, [onChangeInProps]);
  var onOpenChange = useCallback(() => {
    setOpen(open => !open);
  }, []);
  React.useEffect(() => {
    setstudyDatetime(value);
  }, [value]);
  return /*#__PURE__*/React.createElement(DatePicker.RangePicker, _extends({
    dropdownClassName: "sk-range-picker-drop-down",
    allowClear: false,
    onChange: onChange,
    renderExtraFooter: () => {
      var _context;
      return /*#__PURE__*/React.createElement("div", {
        className: "sk-range-picker-footer"
      }, _mapInstanceProperty(_context = _Object$keys(quickSearch)).call(_context, key => /*#__PURE__*/React.createElement("div", {
        key: `range-picker-${key}`,
        className: cx('tag', {
          active: isDateEqual(quickSearch[key], studyDatetime)
        }),
        onClick: () => {
          setstudyDatetime(quickSearch[key]);
          onChange === null || onChange === void 0 ? void 0 : onChange(quickSearch[key]);
          setOpen(false);
        }
      }, ' ', key, ' ')));
    },
    open: open,
    onOpenChange: onOpenChange,
    value: studyDatetime
  }, otherProps));
});
var RangeDatePickerWithConsumer = /*#__PURE__*/React.memo(props => {
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, context => {
    var _context$locale;
    // @ts-ignore
    var locale = ((_context$locale = context.locale) === null || _context$locale === void 0 ? void 0 : _context$locale.DatePicker) || zhCN;
    return /*#__PURE__*/React.createElement(RangeDatePicker, _extends({}, props, {
      locale: locale
    }));
  });
});
export default RangeDatePickerWithConsumer;